module.exports = __webpack_public_path__ + "img/img_29.e914d3e6.png";